export default __webpack_public_path__ + "static/media/aquarium.8ffcae7b.png";